import { forwardRef } from 'react';
import type { SvgIcon, SvgIconProps } from '@mui/material';
import MuiCloseIcon from '@mui/icons-material/Close';
import MuiSearchIcon from '@mui/icons-material/Search';
import {
  Check,
  ChevronDown,
  CreditCard,
  Lock,
  Minus,
  Moon,
  Plus,
  Sun,
  Truck,
} from 'lucide-react';
import type { BaseIconProps, IconComponent } from './types';

export type { BaseIconProps, IconComponent };

function muiIconComponent(Component: typeof SvgIcon) {
  return forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
    <Component ref={ref} {...props} />
  ));
}

function iconComponent(Component: IconComponent) {
  return ({ size = '1rem', ...props }: BaseIconProps) => {
    return <Component size={size} {...props} />;
  };
}

export const CardIcon = iconComponent(CreditCard);
export const CheckIcon = iconComponent(Check);
export const ChevronDownIcon = iconComponent(ChevronDown);
export const CloseIcon = muiIconComponent(MuiCloseIcon);
export const LockIcon = iconComponent(Lock);
export const MinusIcon = iconComponent(Minus);
export const MoonIcon = iconComponent(Moon);
export const PlusIcon = iconComponent(Plus);
export const SearchIcon = muiIconComponent(MuiSearchIcon);
export const SunIcon = iconComponent(Sun);
export const TruckIcon = iconComponent(Truck);
